import React, { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import ImageSection from "./ImageSection";
import SectionHeader from "./SectionHeader";
import GetInTouchButton from "./GetInTouchButton";
import Section from "./Section";

const ImageSectionsGroup = ({
    header,
    text,
    imageSections,
    displayLastButton,
    indexOffset = 0,
}) => (
    <Section className="image-section-group">
        {header && (
            <SectionHeader
                header={header}
                className="image-section-group__header"
            />
        )}
        {text && (
            <Row className="image-section-group__description-row">
                <Col>
                    <p
                        className="image-section-group__description"
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </Col>
            </Row>
        )}
        {imageSections?.map((imageSectionWrapper, i) => (
            <Fragment key={i}>
                <ImageSection {...imageSectionWrapper} flipped={(i + indexOffset) % 2 == 1} />
            </Fragment>
        ))}
    </Section>
);

export default ImageSectionsGroup;
